export default __webpack_public_path__ + "static/media/1486.557314ad.png";